import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=71ec4fc3&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=71ec4fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec4fc3",
  null
  
)

export default component.exports